"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _Indicator = _interopRequireDefault(require("./Indicator"));

require("../styles/_indicators.scss");

function calculateLeftPercent(timestamp, totalDuration) {
  return Number.isNaN(+timestamp) ? null : 100 * (timestamp / totalDuration);
}

function Indicators(_ref) {
  var onClickIndicator = _ref.onClickIndicator,
      userAssignedColors = _ref.userAssignedColors,
      comments = _ref.comments,
      totalDuration = _ref.totalDuration,
      className = _ref.className;
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])("comment-indicators", className)
  }, comments.map(function (comment) {
    var commentId = comment.commentId,
        createdByUser = comment.createdByUser,
        timestamp = comment.timestamp;
    if (!commentId || !createdByUser) return null;
    var leftPercent = calculateLeftPercent(timestamp, totalDuration);
    return null === leftPercent ? null : _react["default"].createElement(_Indicator["default"], {
      key: commentId,
      commentId: commentId,
      onClick: onClickIndicator(comment),
      colour: userAssignedColors[createdByUser.userId],
      leftPercent: leftPercent
    });
  }));
}

var _default = (0, _react.memo)(Indicators);

exports["default"] = _default;